import Vue from 'vue'
import Vuex from 'vuex'
import anime from 'animejs'

Vue.use(Vuex);
import {students} from "./lib/students" // export default
import firebase from "firebase"
var config = {
  apiKey: "AIzaSyDMfnb-2L9cukFbnxWaA-JkYliCdkPSokY",
  authDomain: "kkuvisual2020.firebaseapp.com",
  databaseURL: "https://kkuvisual2020.firebaseio.com",
  projectId: "kkuvisual2020",
  storageBucket: "",
  messagingSenderId: "519015724417"
};
firebase.initializeApp(config);

export const store = new Vuex.Store({
  getters: {
    allStudents(s) {
      return s.students
    },
    allApplicant(s) {
      return s.allApplicant
    }
  },
  state: {
    db: firebase.firestore().collection('BookApplicant'),
    dbRef: firebase.firestore().collection('BookApplicant').orderBy("date", "asc"),
    allApplicant: [],

    photos: [
      { src: 'https://firebasestorage.googleapis.com/v0/b/kkuvisual2020.appspot.com/o/about%2F1.jpeg?alt=media&token=35a5d353-0925-4a6a-82ca-ce491f610c64' },
      { src: 'https://firebasestorage.googleapis.com/v0/b/kkuvisual2020.appspot.com/o/about%2F2.jpeg?alt=media&token=74f967f0-cdc5-45f8-857f-3a8a631b346a' },
      { src: 'https://firebasestorage.googleapis.com/v0/b/kkuvisual2020.appspot.com/o/about%2F3.jpeg?alt=media&token=e89708c6-c0d0-406a-b923-21212c262d56' },
      { src: 'https://firebasestorage.googleapis.com/v0/b/kkuvisual2020.appspot.com/o/about%2F4.jpeg?alt=media&token=f96ef91e-ecc0-41a7-b9ca-f3dab42b300d' },
      { src: 'https://firebasestorage.googleapis.com/v0/b/kkuvisual2020.appspot.com/o/about%2F5.jpeg?alt=media&token=8f613d95-5f21-4325-ac2a-1cf1eed1c210' },
      { src: 'https://firebasestorage.googleapis.com/v0/b/kkuvisual2020.appspot.com/o/about%2F6.jpeg?alt=media&token=85a36171-ca13-40c6-b099-45d8c1b1d529' },
      { src: 'https://firebasestorage.googleapis.com/v0/b/kkuvisual2020.appspot.com/o/about%2F7.jpeg?alt=media&token=42a88662-8be4-4f3b-8dc9-46adff291f73' },
      { src: 'https://firebasestorage.googleapis.com/v0/b/kkuvisual2020.appspot.com/o/about%2F8.jpeg?alt=media&token=72ae145b-15d3-46ca-a181-edec62f80c44' },
      { src: 'https://firebasestorage.googleapis.com/v0/b/kkuvisual2020.appspot.com/o/about%2F9.jpeg?alt=media&token=f77b68de-0de2-4a53-9595-aceade132ac2' },
      { src: 'https://firebasestorage.googleapis.com/v0/b/kkuvisual2020.appspot.com/o/about%2F10.jpeg?alt=media&token=b77d2111-4010-4110-ad93-7d1c44830d0f' },
      { src: 'https://firebasestorage.googleapis.com/v0/b/kkuvisual2020.appspot.com/o/about%2F11.jpeg?alt=media&token=ee4bff9f-9c99-4d29-b249-69ccddae3d9c' },
      { src: 'https://firebasestorage.googleapis.com/v0/b/kkuvisual2020.appspot.com/o/about%2F12.jpeg?alt=media&token=0c6018cf-3064-40e9-844a-d326c80b734f' },
    ],
    students,
  },
  mutations: {
    // 도록신청자 목록
    loadAllApplicant(s, p){ 
        s.dbRef.get().then(function(snapshot) {
            let array = []
            snapshot.forEach(function(doc){
                const item = doc.data()
                item._id = doc._id
                array.push(item)
            })
            s.allApplicant = array.sort(function(a, b) { 
                return a.date - b.date
            })
        })
    },
    // anime
    upDown(s, p) {
      anime({
          targets: p,
          translateY: 12,
          delay: function( el, i) { return i * 200 },
          easing: 'easeInOutQuad',
          direction: 'alternate',
          loop: true,
          duration: 900,
      })
    },
    fireOff(s, p) {
      anime({
        targets: p,
        strokeDashoffset: [anime.setDashoffset, "100%"],
        easing: 'easeInOutSine',
        opacity: 1,
        duration: 2000,
        delay: 300,
      })
    },
    // invitationOpen(s, p) {
    //   anime({
    //     targets: document.querySelector('.invitation-wrapper'),
    //     easing: 'easeOutQuad',
    //     opacity: 1,
    //     translateY: -1000,
    //     duration: 1200,
    //     delay: 3200,
    //   })
    // },
    showList(s, p){
      anime({
        targets: '.students-el',
        opacity: 1,
        duration: 2000,
        delay: function(el, i, l) { return  i * ( Math.random() * 40 ); }
      })
    },
    showDetail(s, p){
      anime({
        targets: '.info-el',
        opacity: 1,
        duration: 2000,
       delay: function(el, i, l) { return i * 150; },
      })
   },
  }
});


// WEBPACK FOOTER //
// ./src/store.js